import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('anns_admin_token');
    if (!token) { setChecking(false); return; }
    API.get('/auth/me')
      .then(res => { if (res.data.success) setAdmin(res.data.admin); })
      .catch(() => { localStorage.removeItem('anns_admin_token'); })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    localStorage.setItem('anns_admin_token', res.data.token);
    setAdmin(res.data.admin);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('anns_admin_token');
    setAdmin(null);
  };

  return (
    <AdminContext.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
